import { PaymentMethod } from './payment-method';

export class PaymentDialogResult {
  public Type?: string;
  public PayMethod: PaymentMethod = new PaymentMethod();
  public OneTimePaymentFirstName?: string;
  public OneTimePaymentLastName?: string;
  public ErrorMessage?: string;
}
